<template>
  <g>
    <path
      d="M20.84 7.46c0-1.23-1-2.23-2.23-2.23h-2.23V4.12a1.11 1.11 0 10-2.23 0v1.11H9.7V4.12a1.11 1.11 0 10-2.23 0v1.11H5.23C4 5.23 3 6.23 3 7.46v1.75h17.84V7.46zM3 18.61c0 1.23 1 2.23 2.23 2.23h13.38c1.23 0 2.23-1 2.23-2.23v-7.9H3v7.9z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CalendarIcon",
});
</script>
